<!--
 * @Description: 
 * @version: 
 * @Author: 李云飞
 * @Date: 2023-07-13 16:18:55
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-02-19 10:42:17
-->
<template>
  <a-layout class="root">
    <a-layout-sider :collapsed="isCollapse">
      <div class="app-logo">LOGO</div>
      <AsideMenu />
    </a-layout-sider>

    <a-layout>
      <a-layout-header>
        <HeaderSection />
      </a-layout-header>
      <TagBar />
      <a-layout-content>
        <div class="container">
          <router-view v-slot="{ Component }">
            <keep-alive :include="keepAliveNameList"
                        :max="30">
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </div>
      </a-layout-content>
    </a-layout>

  </a-layout>
</template>

<script setup>
import { computed } from 'vue';
import { useSystemStore } from '@/store/system.js';
import AsideMenu from './components/AsideMenu.vue';
import HeaderSection from './components/HeaderSection.vue';
import TagBar from './components/TagBar.vue';

// 菜单是否折叠状态
const isCollapse = computed(() => useSystemStore().getSideMenuCollapse);

// 需要缓存的组件名称
const keepAliveNameList = computed(() => useSystemStore().getKeepAliveNameList || []);
</script>


<style lang="less" scoped>
.root {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
}

.app-logo {
  text-align: center;
  line-height: 1.4;
  padding: 12px 0;
  font-size: 20px;
  color: #fff;
}

.container {
  padding: 8px;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

// 进入动画的起始状态（进入动画前的样式）
.fade-enter-from {
  opacity: 0.2;
  transform: translate(-100%, 0);
}

// 进入动画的生效状态（进入动画的过度）
.fade-enter-active {
  transition: all 1000ms ease-out 500ms;
}

// 离开动画的结束状态（离开动画的样式）
.fade-leave-to {
  opacity: 0;
  // transform: translate(0, 0);
}
// 离开动画的生效状态（离开动画的过度）
.fade-leave-active {
  transition: all 50ms linear;
}
</style>
